import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "customer-seating-chart"
};
var _hoisted_2 = {
  class: "chart-container",
  style: {
    "width": "100%",
    "min-width": "400px",
    "min-height": "600px"
  }
};
var _hoisted_3 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("dialog", null, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    id: _ctx.divId,
    style: {
      "min-height": "80vh"
    }
  }, null, 8, _hoisted_3)])])])])]);
}